/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable security/detect-object-injection */
/* eslint-disable no-debugger */
/* eslint-disable no-param-reassign */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable import/no-unresolved */
import Button from "@mui/material/Button";
import CustomModal from "src/shared/CustomModal";
import { useState, useEffect } from "react";
import { useFormik } from "formik";
import { useSelector, useDispatch } from "react-redux";
import {
  SET_TOAST_ERROR,
  saveNewLeadDetailsAction,
  setPostMEFLoading,
  setStepDetails
} from "src/redux/Actions/common";
import { MasterAction } from "src/redux/Actions/Masters";
import {
  SET_CHANNEL,
  SET_GENDER_DETAILS,
  SET_PRODUCT,
  SET_PRODUCT_PARTNER,
  SET_LOAN_VALUES
} from "src/redux/Types/Masters";
import { channel, genderDetails, product } from "src/services/Master";
import store from "src/redux/store";
import CustomLoader from "src/shared/CustomLoader";
import { useAppSelector } from "src/utils/hooks/useAppSelector";
import CustomConfirmationModal from "src/shared/CustomConfirmationModal";
import { useNavigate } from "react-router-dom";
import leadValidationSchema, {
  constructDEPayload,
  initialCreateLeadsValues
} from "src/helpers/FormDetails/CreateDetails";
import createLeadAPI from "src/services/FormDetails/CreateLead";
import { useMutation } from "react-query";
import StorageService from "src/utils/Storage/storageService";
import { uploadMultipleFiles } from "src/services/UploadSignedMefForm";
import {
  documentsTypes,
  uploadFilesMandatoryFor
} from "src/helpers/FormDetails/CreateDetails/interfaces";
import CreateNewLead from "./CreateLeads";

function CreateNewLeadDetails() {
  const navigate = useNavigate();
  const NewLeadCreateDetails = useAppSelector((state: any) => state.newLeadDetails) || {};
  const dispatch = useDispatch();
  const [modalOpen, setModalOpen] = useState(false);
  const [isMasterLoaded, setIsMasterLoaded] = useState(false);
  const [hasError, setHasError] = useState(false);
  const [openConfirmationModal, setOpenConfirmationModal] = useState(false);
  const [isSaved, setIsSaved] = useState(false);
  const [productsApiError, setProductsApiError] = useState(false);
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const [leadId, setLeadId] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const [channelApiError, setChannelApiError] = useState(false);
  const loanTerm = useAppSelector((state) => state.masterdata_reducer?.loanAmount) || {};
  const loggedInUser = StorageService.getFromLocalStorage("user");

  const { mutate: fetchAllData } = useMutation(genderDetails, {
    retry: false,
    onSuccess: async (response) => {
      const genderData = response.data || {};
      const genderDataList: string[] = Object.values(genderData) || [];
      setIsMasterLoaded(true);
      dispatch(MasterAction(SET_GENDER_DETAILS, genderDataList));
      setHasError(false);
      setHasUnsavedChanges(false);
    },
    onError: () => {
      setHasError(true);
    }
  });

  const { mutate: fetchChannel } = useMutation(channel, {
    retry: false,
    onSuccess: async (response) => {
      dispatch(MasterAction(SET_CHANNEL, response));
      setIsMasterLoaded(true);
      setChannelApiError(false);
    },
    onError: () => {
      setChannelApiError(true);
    }
  });

  useEffect(() => {
    fetchAllData();
    fetchChannel();
  }, []);

  const combinedSelector = (state: any) => {
    const genderData = state.masterdata_reducer.genderDetails || {};
    const genderDataList = genderData || {};
    return { genderDataList };
  };
  const { genderDataList } = useSelector(combinedSelector);

  const { mutate: mutateCreateLead } = useMutation(createLeadAPI, {
    onError: () => {
      setLoading(false);
    }
  });

  const { mutate: mutateMEFMultipleFileUpload, isLoading: isMEFMultipleFileUploadLoading } =
    useMutation(uploadMultipleFiles, {
      retry: false,
      onSuccess: async () => {
        setLoading(false);
        setOpenConfirmationModal(true);
        setHasUnsavedChanges(false);
        store.dispatch(setPostMEFLoading(true));
        store.dispatch(
          SET_TOAST_ERROR({
            error: true,
            type: "success",
            message: "Successfully Uploaded Files"
          })
        );
      },
      onError: () => {
        setLoading(false);
        store.dispatch(
          SET_TOAST_ERROR({
            error: true,
            duration: 4000,
            message: "Failed to upload Files. Try again"
          })
        );
      }
    });
  const formik = useFormik({
    enableReinitialize: true,
    validateOnMount: false,
    validateOnBlur: false,
    initialValues: initialCreateLeadsValues,
    validationSchema: leadValidationSchema(loanTerm, loggedInUser?.role),
    onSubmit: async (values) => {
      setLoading(true);
      if (leadId) {
        mutateMEFMultipleFileUpload({
          leadId,
          files: formik?.values?.files as any[],
          fileNames: documentsTypes
        });
        return;
      }
      const payload = constructDEPayload(values, genderDataList);
      mutateCreateLead(payload, {
        onSuccess: (response) => {
          setLeadId(response.data.id);
          if (uploadFilesMandatoryFor(loggedInUser?.role)) {
            mutateMEFMultipleFileUpload({
              leadId: response?.data?.id,
              files: formik?.values?.files as any[],
              fileNames: documentsTypes
            });
            return;
          }
          setLoading(false);
          setOpenConfirmationModal(true);
          setHasUnsavedChanges(false);
          store.dispatch(setPostMEFLoading(true));
        }
      });
    }
  });

  const { mutate: fetchProducts } = useMutation(product, {
    retry: false,
    onSuccess: async (response) => {
      const { productId, partnerId } = formik.values;
      const filteredData = response?.filter(
        (item: { productId: number | null; partnerId: string }) =>
          Number(item.productId) === Number(productId) &&
          String(item.partnerId).trim().toLowerCase() === String(partnerId).trim().toLowerCase()
      );
      dispatch(MasterAction(SET_PRODUCT, response));
      dispatch(MasterAction(SET_PRODUCT_PARTNER, response));
      dispatch(
        MasterAction(SET_LOAN_VALUES, {
          productMaster: filteredData[0]?.productMaster
        })
      );
      setIsMasterLoaded(true);
      setProductsApiError(false);
    },
    onError: () => {
      setProductsApiError(true);
    }
  });

  useEffect(() => {
    if (formik.values.productId && formik.values.partnerId) {
      fetchProducts();
    }
  }, [formik.values.productId, formik.values.partnerId]);

  useEffect(() => {
    setHasUnsavedChanges(JSON.stringify(formik.values) !== JSON.stringify(NewLeadCreateDetails));
  }, [formik.values, NewLeadCreateDetails]);

  async function handleSave() {
    try {
      const obj = saveNewLeadDetailsAction(formik.values);
      await store.dispatch(obj);
      store.dispatch(
        SET_TOAST_ERROR({
          error: true,
          type: "success",
          message: "Lead Details Saved Successfully"
        })
      );
      setIsSaved(true);
    } catch (error: any) {
      setLoading(false);
      const errorMessage = error.message || "Error Saving Lead Details";
      dispatch(
        SET_TOAST_ERROR({
          error: true,
          type: "error",
          duration: 4000,
          message: errorMessage
        })
      );
    }
  }

  useEffect(() => {
    if (NewLeadCreateDetails && Object.keys(NewLeadCreateDetails).length > 0) {
      formik.setValues(NewLeadCreateDetails);
    }
  }, [NewLeadCreateDetails]);

  if (hasError || productsApiError || channelApiError) {
    return (
      <div className="flex flex-col items-center justify-center h-screen">
        <p className="font-bold text-lg mb-4">No Data Found</p>
        <Button
          variant="contained"
          classes={{ contained: "!rounded-lg" }}
          className="!uppercase m-auto"
          onClick={() => {
            fetchProducts();
            fetchAllData();
            fetchChannel();
          }}
        >
          RETRY
        </Button>
      </div>
    );
  }

  if (loading || !isMasterLoaded || isMEFMultipleFileUploadLoading) {
    return <CustomLoader />;
  }

  return (
    <div>
      {openConfirmationModal && leadId && (
        <CustomConfirmationModal
          text={
            <div>
              <p>Lead Created Successfully</p>
            </div>
          }
          onNext={() => {
            store.dispatch(
              setStepDetails({
                parentStepNo: 1,
                proposerStepNo: 1,
                reviewStepNo: 1,
                jointStepNo: 1
              })
            );
            navigate(`/form-details/${leadId}`);
            dispatch(setPostMEFLoading(false));
          }}
          onCancel={() => {
            setOpenConfirmationModal(false);
            navigate("/dashboard");
            dispatch(setPostMEFLoading(false));
          }}
        />
      )}
      <CustomModal modalOpen={modalOpen} setModalOpen={setModalOpen} />
      <div className="min-h-screen bg-whiteSmoke pt-8 pb-19.5">
        <div className="w-full md:w-805/1000 mx-auto bg-white h-fit pt-8.5 pb-10 pr-10 pl-10.25 rounded-1.5xl">
          <div className="mt-6">
            <CreateNewLead formik={formik} genderDataList={Object.values(genderDataList)} />
          </div>
          <div className="mt-10 flex justify-center">
            <Button
              variant="outlined"
              classes={{ outlined: "!rounded-lg" }}
              onClick={handleSave}
              disabled={
                !Object.keys(initialCreateLeadsValues).find(
                  (key: string) => initialCreateLeadsValues[key] !== formik.values[key]
                )
              }
              className="!text-black !uppercase h-13 w-37.5 rounded-lg !mr-10"
            >
              SAVE
            </Button>

            <Button
              disabled={hasUnsavedChanges || !isSaved}
              variant="contained"
              classes={{ contained: "!rounded-lg" }}
              onClick={() => {
                if (!formik.isValid) {
                  formik.handleSubmit();
                  setModalOpen(true);
                } else {
                  formik.handleSubmit();
                }
              }}
              className="!uppercase h-13 w-37.5 rounded-lg"
            >
              SUBMIT
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CreateNewLeadDetails;
